import { render, staticRenderFns } from "./ComboService.vue?vue&type=template&id=f085ac5e"
import script from "./ComboService.vue?vue&type=script&lang=js"
export * from "./ComboService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports